module.exports = __webpack_public_path__ + "img/level_six_hover.63ae86a0.png";